module.exports = __webpack_public_path__ + "img/team-uscpaloma@2x.de36bd1c.jpg";